import BaseComponent from 'foundation/base-component';
import CountUp from 'countup.js';

const QUANTITY_FLOAT = 2;
const QUANTITY_INT = 0;

export default class PlayerProfilesStats extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.instance = null;

        this.init();
    }

    init() {
        this.createObserver();
    }

    createObserver() {
        const observer = new IntersectionObserver((observables) => {
            const observable = observables[0];

            if (observable.intersectionRatio > 0) {
                if (this.refs.counterFloat) {
                    this.moveHandler(this.refs.counterFloat, true);
                }

                if (this.refs.counterPercent) {
                    this.moveHandler(this.refs.counterPercent, false);
                }
            }
        });

        observer.observe(this.element);
    }

    moveHandler(arrayItems, float) {
        const options = {
            instance: this.instance,
            node: null,
            value: null
        };

        if (arrayItems) {
            for (let i = 0; i < arrayItems.length; i++) {
                options.node = arrayItems[i];

                options.value = parseFloat(this.getAttribute(options.node, 'value'));

                if (float) {
                    this.moveAnimation(options, QUANTITY_FLOAT);
                } else {
                    this.moveAnimation(options, QUANTITY_INT);
                }
            }
        }
    }

    moveAnimation(options, quantity) {
        options.instance = new CountUp(options.node, 0, options.value, quantity);
        options.instance.start();
    }
}
